import http from '../const/http-common'

const getPermission = (permissionInfo) => {
  return http.post('/v1/permission/get', permissionInfo);
}

const savePermission = (permissionInfo) => {
  return http.post('/v1/permission/save', permissionInfo);
}

const permissionService = {
  getPermission,
  savePermission,
}

export default permissionService